module.exports = __webpack_public_path__ + "img/oops.8f26c406.png";